import { render, staticRenderFns } from "./CreatePoint.vue?vue&type=template&id=dce3d9e8&"
import script from "./CreatePoint.vue?vue&type=script&lang=js&"
export * from "./CreatePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports